import ReactDatePicker from 'react-datepicker';
import { Dropdown, SearchInput } from '../../../../components';
import { DropdownOption } from '../../../../components/Dropdown/interfaces';
import SelectSubAccountDropdown from '../../../../components/global-components/selectSubAccountDropdown';
import './LegsHistoryFilters.scss';

interface Props {
  search: string;
  onChangeSearch: (search: string) => void;
  startDate: Date | null;
  endDate: Date | null;
  onChangeDateRange: (dates: [Date | null, Date | null]) => void;
  onChangeDateRangeRaw: (event: React.FocusEvent<HTMLInputElement>) => void;
  userEmail: string;
  onChangeUserEmail: (email: string) => void;
  usersOptions: DropdownOption[];
  subAccountNumber: string;
  onChangeSubAccountNumber: (subAccountNumber: string) => void;
  isAdmin: boolean;
}

export default function LegsHistoryFilters({
  search,
  onChangeSearch,
  startDate,
  endDate,
  onChangeDateRange,
  onChangeDateRangeRaw,
  userEmail,
  onChangeUserEmail,
  usersOptions,
  subAccountNumber,
  onChangeSubAccountNumber,
  isAdmin,
}: Props) {
  return (
    <div className='LegsHistoryFilters'>
      <div className='SearchInputContainer'>
        <SearchInput
          value={search}
          onChange={onChangeSearch}
        />
      </div>
      <div className='DateRangeContainer'>
        <label className='form-label labelText'>
          Date Range
        </label>
        <ReactDatePicker
          className='form-control ubbe-input DateRange'
          selected={startDate}
          startDate={startDate}
          endDate={endDate}
          onChange={onChangeDateRange}
          onChangeRaw={onChangeDateRangeRaw}
          placeholderText='Select dates.'
          dateFormat='yyyy-MM-dd'
          monthsShown={2}
          calendarIconClassname='calendarIcon'
          showIcon
          selectsRange
        />
      </div>
      <div className='UsersContainer'>
        <Dropdown
          label='Users'
          options={usersOptions}
          selectedOption={userEmail}
          onSelectOption={onChangeUserEmail}
        />
      </div>
      {isAdmin && (
      <div className='SubAccountNumberContainer'>
        <label className='form-label labelText'>
          Accounts
        </label>
        <SelectSubAccountDropdown
          selectedSubAccount={subAccountNumber}
          setSelectedSubAccount={onChangeSubAccountNumber}
        />
      </div>
      )}
    </div>
  );
}
